import { Trans } from "@lingui/macro";
import { useState } from "react";
import { Soribot } from "../../models/Soribot";
import { BaseSource } from "../../models/SoribotSource";
import { UtilApp } from "../../services/Utils/UtilApp";
import { SoribotDatasourcesDocs } from "./SoribotDatasourcesDocs";
import { SoribotDatasourcesMemos } from "./SoribotDatasourcesMemos";
import { SoribotDatasourcesOfficeNote } from "./SoribotDatasourcesOfficeNote";
import { SoribotDatasourcesUploadFiles } from "./SoribotDatasourcesUploadFiles";
import { My } from "../../services/My";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { Button } from "../../components/ui/button";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import Page from "../../const/Page";

type SubPage = 'officenote' | 'files' | 'memos' | 'docs';
export const SoribotDatasources: React.FC<{ bot: Soribot }> = ({ bot }) => {
  const [subpage, setSubpage] = useState<SubPage>('docs');
  const isNotRetrieval = bot.subType && bot.subType !== 'retrieval';

  return <div className="space-y-4">
    {isNotRetrieval && <div className="p-3 bg-yellow-50 text-yellow-700 rounded text-sm border border-yellow-200"><Trans>This page only applies to bots with Knowledge Retrieval.</Trans></div>}

    <Tabs value={subpage} onValueChange={(val) => setSubpage(val as SubPage)} className="w-full">
      <TabsList className="grid w-full grid-cols-4">
        <TabsTrigger value="docs"><Trans>Knowledge Docs</Trans></TabsTrigger>
        <TabsTrigger value="memos"><Trans>Channel Memos</Trans></TabsTrigger>
        <TabsTrigger value="files"><Trans>PDF Files</Trans></TabsTrigger>
        <TabsTrigger value="officenote"><Trans>OfficeNote</Trans></TabsTrigger>
      </TabsList>

      <div className="mt-4">
        <TabsContent value="docs"><SoribotDatasourcesDocs bot={bot} /></TabsContent>
        <TabsContent value="memos"><SoribotDatasourcesMemos bot={bot} /></TabsContent>
        <TabsContent value="files"><SoribotDatasourcesUploadFiles bot={bot} /></TabsContent>
        <TabsContent value="officenote"><SoribotDatasourcesOfficeNote bot={bot} /></TabsContent>
      </div>
    </Tabs>

    <div className="pt-4 border-t">
      <Link to={`/soribot/knowledgeviewer/${bot.id}`}>
        <Button variant="outline" className="w-full text-card-foreground">
          <Trans>View Bot Knowledge</Trans> <ExternalLink className="w-4 h-4 ml-2" />
        </Button>
      </Link>
    </div>
  </div>
}

export function getSourceInfo(toRemove: boolean, p: BaseSource) {
  return <>
    {p.error ? <span className="ml-2 text-destructive text-xs" title={p.error}>{p.error}</span>
      :
      <span className="ml-2 text-xs text-muted-foreground">
        {toRemove ? <span className="text-destructive"><Trans>Sync to remove</Trans></span>
          :
          <>{p.grounded ? <Trans>Synced {UtilApp.dateStrToTimeAndDay(p.grounded, My.user.lang)}</Trans>
            :
            <span className="text-destructive"><Trans>Awaiting sync</Trans> | <Trans>Created {UtilApp.dateStrToTimeAndDay(p.created, My.user.lang)}</Trans></span>}</>
        }
        &nbsp;{p.noParts !== undefined && <span>(<Trans>{p.noParts} chunks</Trans>)</span>}
      </span>
    }</>
}
export default SoribotDatasources;